/**
 * Login-aegne MFA-klient (teine faktor). Staff-kontodel võib olla 2FA - login
 * tagastab `mfaRequired`, mille lahendab `/auth/mfa/verify`. Port web_account-ist
 * (ainult login-osa; haldus/enroll on web_account-i Turvalisuse all).
 */
import { api } from "./api";
import type { StaffUser } from "./auth";

export interface MfaChallengeInfo {
  methods: { totp: boolean; email_otp: boolean; backup_code: boolean };
}

export const mfaApi = {
  challengeInfo: (pendingToken: string) =>
    api.post<MfaChallengeInfo>("/auth/mfa/challenge-info", { pendingToken }),
  emailSendLogin: (pendingToken: string) =>
    api.post<{ ok: true; sentTo?: string }>("/auth/mfa/email/send", { pendingToken }),
  /** Login-aegne teine faktor → tagastab täis-kasutaja. */
  verify: (pendingToken: string, code: string) =>
    api.post<StaffUser>("/auth/mfa/verify", { pendingToken, code }),
};
